import ResourceContainer from "./container/resourceContainer";
export default ResourceContainer;
